import axios from 'axios';
export async function register(payload) {
	return await axios.post(`/api/register`, payload);
}
